import { Container, LinearProgress, Box, Grid } from '@mui/material';

const LinearLoader = () => {
  return (
    <Container>
      <Box pt={3}>
        <Grid container>
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default LinearLoader;